/**
 * Creates a debounced version of the provided function that delays its execution
 * until after a specified wait time has elapsed since the last time it was invoked.
 *
 * @param {T} callback - The function to debounce.
 * @param {number} delay - The number of milliseconds to delay the execution of the callback.
 * @return {(...args: Parameters<T>) => void} A debounced version of the input callback.
 */
export function debounce<T extends (...args: any[]) => void>(
  callback: T,
  delay: number
): (...args: Parameters<T>) => void {
  let timer: ReturnType<typeof setTimeout>;
  return (...args: Parameters<T>) => {
    clearTimeout(timer); // Clear the previous timer
    timer = setTimeout(() => callback(...args), delay); // Set a new timer
  };
}
